/* Snelkoop-lade B "Alleen wat kan" (registry #109, Salomon 03-11: "B: alleen wat kan").
   Draait op het event van quick-add.js, zodat Wonders eigen code ongewijzigd blijft.
   - Eén optie: alleen leverbare maten als tegels, geen voorgekozen maat, uitverkochte maten achter "Maat niet bij?".
   - Twee opties (kleur + maat): compacte opmaak, alle maten, het bestaande blok "Houd me op de hoogte".
   - Scripts uit de opgehaalde productpagina draaien niet vanzelf (DOMParser): leverregel en back-in-stock draaien we hier,
     met een document dat alleen in de lade zoekt, want op een productpagina staan dezelfde blokken ook op de pagina zelf. */
(function () {
  'use strict';
  var T, bron = document.getElementById('bn-lade-t');
  try { T = JSON.parse(bron.textContent); } catch (e) { return; }
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function ladeDocument(root) {
    return new Proxy(document, {
      get: function (d, k) {
        if (k === 'querySelector') return function (s) { return root.querySelector(s); };
        if (k === 'querySelectorAll') return function (s) { return root.querySelectorAll(s); };
        if (k === 'readyState') return 'complete';
        var v = d[k];
        return typeof v === 'function' ? v.bind(d) : v;
      }
    });
  }
  function draaiScripts(info, patroon) {
    window.__bnLadeDoc = ladeDocument(info);
    info.querySelectorAll('script').forEach(function (s) {
      if ((s.type && s.type !== 'text/javascript') || !patroon.test(s.textContent)) return;
      var n = document.createElement('script');
      n.textContent = '(function(document){' + s.textContent + '\n})(window.__bnLadeDoc);';
      document.head.appendChild(n);
      n.remove();
    });
    delete window.__bnLadeDoc;
  }
  function varianten(vo) {
    var s = vo && vo.querySelector('script[type="application/json"]');
    try { var d = JSON.parse(s.textContent); return Array.isArray(d) ? d : []; } catch (e) { return []; }
  }
  function isMaat(info) {
    try { return Object.keys(JSON.parse(info.querySelector('[data-bn-voorraad-maten]').textContent).maten || {}).length > 0; } catch (e) { return false; }
  }
  function el(tag, cls, tekst) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (tekst !== undefined) e.textContent = tekst;
    return e;
  }

  var detailsTekst = '';
  function regel(info) {
    var r = el('div', 'bn-lade-regel');
    var lever = info.querySelector('[data-bn-levering], [data-bn-maatwerk]');
    var details = info.querySelector('.wt__quick-buy__view-all-container');
    if (details) {
      detailsTekst = details.textContent.trim() || detailsTekst;
    } else if (detailsTekst) {
      /* Wonder gooit de link weg als de lade sluit na toevoegen (product-form.js): bij de volgende lade opnieuw maken. */
      var titel = info.querySelector('.wt-product__name a');
      details = el('div', 'wt__quick-buy__view-all-container');
      var a = el('a', '', detailsTekst);
      a.href = titel ? titel.getAttribute('href') : '#';
      details.appendChild(a);
    }
    if (lever) r.appendChild(lever);
    if (details) r.appendChild(details);
    var koop = info.querySelector('.main-product__buy-buttons--container');
    if (koop) koop.parentNode.insertBefore(r, koop);
  }

  function melden(info, uit, maatOptie) {
    var koop = info.querySelector('.main-product__buy-buttons--container');
    var knop = el('button', 'bn-lade-nietbij', T.niet_bij);
    knop.type = 'button';
    knop.setAttribute('aria-expanded', 'false');
    var form = el('form', 'bn-lade-melden');
    form.hidden = true;
    form.noValidate = true;
    form.appendChild(el('p', '', T.welke));
    var chips = el('div', 'bn-lade-chips');
    chips.setAttribute('role', 'group');
    uit.forEach(function (u) {
      var c = el('button', 'bn-lade-chip', u.maat);
      c.type = 'button';
      c.dataset.id = u.id;
      c.dataset.maat = u.maat;
      c.setAttribute('aria-pressed', uit.length === 1 ? 'true' : 'false');
      chips.appendChild(c);
    });
    form.appendChild(chips);
    var rij = el('div', 'bn-lade-rij');
    var mail = el('input');
    mail.type = 'email';
    mail.autocomplete = 'email';
    mail.placeholder = T.mail;
    mail.setAttribute('aria-label', T.mail);
    var verstuur = el('button', 'bn-lade-verstuur', T.knop);
    verstuur.type = 'submit';
    rij.appendChild(mail);
    rij.appendChild(verstuur);
    form.appendChild(rij);
    var status = el('p', 'bn-lade-status');
    status.setAttribute('role', 'status');
    form.appendChild(status);
    koop.parentNode.insertBefore(knop, koop);
    koop.parentNode.insertBefore(form, koop);

    knop.addEventListener('click', function () {
      form.hidden = !form.hidden;
      knop.setAttribute('aria-expanded', String(!form.hidden));
      if (!form.hidden) form.scrollIntoView({ block: 'nearest' });
    });
    chips.addEventListener('click', function (e) {
      var c = e.target.closest('.bn-lade-chip');
      if (!c) return;
      chips.querySelectorAll('.bn-lade-chip').forEach(function (b) { b.setAttribute('aria-pressed', b === c ? 'true' : 'false'); });
      status.textContent = '';
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var c = chips.querySelector('[aria-pressed="true"]');
      var adres = mail.value.trim();
      status.className = 'bn-lade-status is-fout';
      if (!c) { status.textContent = T.kies_eerst; return; }
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(adres)) { status.textContent = T.mail_fout; return; }
      status.className = 'bn-lade-status';
      status.textContent = T.bezig;
      verstuur.disabled = true;
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(T.key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
        body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: adres } } } }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + c.dataset.id } } } } })
      }).then(function (r) {
        if (r.status === 202 || r.ok) {
          chips.hidden = true; rij.hidden = true;
          chips.style.display = rij.style.display = 'none';
          form.querySelector('p').style.display = 'none';
          status.className = 'bn-lade-status is-gelukt';
          status.textContent = maatOptie ? T.gelukt.replace('{maat}', function () { return c.dataset.maat; }) : T.gelukt_product;
        } else { throw new Error(r.status); }
      }).catch(function () {
        status.className = 'bn-lade-status is-fout';
        status.textContent = T.fout;
        verstuur.disabled = false;
      });
    });
  }

  function modusB(lade, info, optie, lijst) {
    var maatOptie = isMaat(info), lev = [], uit = [];
    optie.querySelectorAll('.f-button__list__item').forEach(function (li) {
      var input = li.querySelector('input');
      if (!input) return;
      var v = lijst.filter(function (x) { return x.option1 === input.value; })[0];
      var kan = v ? v.available : !input.classList.contains('disabled');
      if (kan) lev.push(input);
      else { li.classList.add('bn-uit'); if (v) uit.push({ maat: input.value, id: v.id }); }
    });
    if (lev.some(function (i) { return i.value.length > 5; })) optie.classList.add('bn-lade-lang');
    var kop = optie.querySelector('.wt-product__option__wrapper');
    var label = optie.querySelector('.wt-product__option__title .label');
    if (label) label.textContent = maatOptie ? T.kies_maat : label.textContent.replace(/\s*:\s*$/, '');
    if (kop && maatOptie) kop.appendChild(el('span', 'bn-lade-telling', lev.length === 1 ? T.een_leverbaar : T.n_leverbaar.replace('{n}', lev.length)));

    var knop = info.querySelector('.js-add-to-cart');
    var tekst = knop && knop.querySelector('.wt-btn__label span');
    if (knop && tekst) {
      if (lev.length > 1) {
        lev.forEach(function (i) { i.checked = false; });
        optie.querySelectorAll('.f-button__list__item--active').forEach(function (a) { a.classList.remove('f-button__list__item--active'); });
        knop.disabled = true;
        tekst.textContent = T.kies_maat;
        optie.addEventListener('change', function () { tekst.textContent = T.in_wagen; }, { once: true });
      }
    }
    if (uit.length) melden(info, uit, maatOptie);
    if (!lev.length) { var nb = info.querySelector('.bn-lade-nietbij'); if (nb) nb.click(); }
  }

  function maak() {
    var lade = document.querySelector('.wt__quick-buy');
    var info = lade && lade.querySelector('.wt-product__info');
    if (!info) return;
    var bak = lade.querySelector('.wt__quick-buy__container');
    if (!bak.querySelector('.bn-lade-grab')) {
      var grab = el('div', 'bn-lade-grab');
      bak.insertBefore(grab, bak.firstChild);
      var y = null;
      grab.addEventListener('touchstart', function (e) { y = e.touches[0].clientY; }, { passive: true });
      grab.addEventListener('touchmove', function (e) { if (y !== null) bak.style.transform = 'translateY(' + Math.max(0, e.touches[0].clientY - y) + 'px)'; }, { passive: true });
      grab.addEventListener('touchend', function (e) {
        if (y === null) return;
        var d = e.changedTouches[0].clientY - y;
        y = null; bak.style.transform = '';
        if (d > 70) { var c = lade.querySelector('.close-btn'); if (c) c.click(); }
      });
    }
    var vo = info.querySelector('variant-options');
    var opties = vo ? vo.querySelectorAll('.wt-product__option') : [];
    var eenOptie = opties.length === 1 && opties[0].querySelector('.f-button__list');
    lade.classList.remove('bn-lade--b', 'bn-lade--compact');
    lade.classList.add(eenOptie ? 'bn-lade--b' : 'bn-lade--compact');
    if (eenOptie) {
      draaiScripts(info, /data-bn-levering|data-bn-maatwerk/);
      modusB(lade, info, opties[0], varianten(vo));
    } else {
      draaiScripts(info, /data-bn-levering|data-bn-maatwerk|data-bn-voorraad/);
    }
    regel(info);
    var knop = info.querySelector('.js-add-to-cart');
    var tekst = knop && knop.querySelector('.wt-btn__label span');
    if (knop) knop.setAttribute('data-custom-add-label', T.in_wagen);
    if (tekst && !knop.disabled) tekst.textContent = T.in_wagen;
  }
  subscribe(PUB_SUB_EVENTS.quickBuyDrawerOpen, function () { setTimeout(maak, 0); });
  subscribe(PUB_SUB_EVENTS.quickBuyDrawerClose, function () {
    var lade = document.querySelector('.wt__quick-buy');
    if (lade) lade.classList.remove('bn-lade--b', 'bn-lade--compact');
  });
})();
